import { styled } from "themes"

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  padding: 32px 0;
`

export const Text = styled.div`
  font-size: 12px;
  margin-bottom: 4px;
`

export const List = styled.div`
  display: flex;
`

export const ListItem = styled.div`
  margin-right: 8px;
  font-size: 32px;
  cursor: pointer;
  &:last-child {
    margin-right: 0;
  }
`
